import "./platinum.css";
export default function Platinum() {
  return (
    <div className="Platinum">
      <div className="PlatinumHeader">
        LET’S <span>FANCY CUT</span>
        <br className="br-portrait " /> TO THE CHASE
      </div>
      <div className="PlatinumContent">
        <div className="PlatinumText">
          <p>
            {" "}
            Frumusețea strălucește în toate formele ei{" "}
            <br className="br-portrait " /> în colecția <b>Fancy Cuts</b>.<br />
          </p>
        </div>
      </div>
    </div>
  );
}
